import React from 'react';
import { BackButtonStyled, Arrow, Wrapper } from './Styled';

interface BackButtonProps {
  children: string;
  onClick: () => void;
  fontSize?: number;
  margin?: string;
}

const BackButton = (props: BackButtonProps) => {
  const { onClick, children, margin, fontSize } = props;

  return (
    <>
      <Wrapper margin={margin}>
        <Arrow />
        <BackButtonStyled onClick={onClick} fontSize={fontSize}>
          {children}
        </BackButtonStyled>
      </Wrapper>
    </>
  );
};

BackButton.defaultProps = {
  children: '',
};

export default BackButton;
export { BackButton };
